import React from 'react';
import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

// Back / Next buttons for the multi-step dialogs (MobileStepper). Next is the
// primary action, styled like every other primary button via the MUI theme.

export function StepNextButton({ children, onClick, disabled }) {
  return (
    <Button
      variant='contained'
      color='primary'
      disabled={disabled}
      onClick={onClick}
      endIcon={<KeyboardArrowRight />}
    >
      {children}
    </Button>
  );
}

export function StepBackButton({ onClick, disabled }) {
  return (
    <Button
      color='primary'
      disabled={disabled}
      onClick={onClick}
      startIcon={<KeyboardArrowLeft />}
    >
      Back
    </Button>
  );
}
